/**
 * Generates a username from the customer's display name with random characters
 * @param displayName - The customer's display name
 * @returns A formatted username email address with the display name (truncated to 80 chars) and random suffix
 */
export const generateUsername = (displayName: string): string => {
  const baseUsername = displayName
    .toLowerCase()
    .replace(/\s+/g, '_') // all whitespace to underscore
    .replace(/[^a-z0-9_]/g, '') // remove non-alphanumeric characters
    .replace(/_+/g, '_') // remove consecutive underscores
    .slice(0, 80); // truncate to 80 characters

  // Generate 32 random characters (valid email characters: alphanumeric, dot, hyphen, underscore)
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const randomArray = new Uint8Array(3);
  crypto.getRandomValues(randomArray);

  const randomString = Array.from(randomArray)
    .map(byte => chars[byte % chars.length])
    .join('');

  return `guard+${baseUsername}-${randomString}@praetorian.com`;
};
